
var id = "upload";
var markup = "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"upload\">\n<path d=\"M5.41601 6.80401C5.63867 7.12237 6.07617 7.20049 6.39453 6.97783L9.29687 4.95049V14.8372C9.29687 15.2259 9.61133 15.5403 10 15.5403C10.3887 15.5403 10.7031 15.2259 10.7031 14.8372V4.97979L13.6133 6.99541C13.9355 7.21807 14.373 7.1419 14.5898 6.82354C14.8066 6.50518 14.7227 6.06768 14.4004 5.84502L10.3867 3.06377C10.3809 3.05987 10.377 3.05791 10.3711 3.05401C10.1348 2.88604 9.81054 2.87627 9.56054 3.0501L5.58984 5.82549C5.27148 6.04815 5.19531 6.48565 5.41601 6.80401Z\" fill=\"white\" />\n<path d=\"M18.0469 12.5C17.6582 12.5 17.3438 12.8145 17.3438 13.2031V16.9004C17.3438 17.1465 17.2129 17.3438 17.0508 17.3438H2.94922C2.78711 17.3438 2.65625 17.1445 2.65625 16.9004V13.2031C2.65625 12.8145 2.3418 12.5 1.95312 12.5C1.56445 12.5 1.25 12.8145 1.25 13.2031V17.0508C1.25 17.9883 2.01172 18.75 2.94922 18.75H17.0508C17.9883 18.75 18.75 17.9883 18.75 17.0508V13.2031C18.75 12.8145 18.4355 12.5 18.0469 12.5Z\" fill=\"white\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
